<template>
	<div>
		<vx-card :title="$t('Preferences.FilterSearchTitle')" class="mb-base" id="search-type">
			<p>
				{{ $t("Preferences.FilterSearchText") }}
			</p>

			<vs-alert icon="warning" active="true" color="warning" class="mt-5">
				<span>{{ $t("Preferences.FilterSearchNote") }} </span>
			</vs-alert>

			<ul class="demo-alignment">
				<li>
					<vs-radio v-model="filterType" :vs-value="true">{{ $t("Preferences.FindExactly") }}</vs-radio>
				</li>
				<li>
					<vs-radio v-model="filterType" :vs-value="false">{{ $t("Preferences.FindCoincidence") }}</vs-radio>
				</li>
			</ul>

			<vs-button type="filled" @click.prevent="updatePreferences('filter_exact_values')" class="mt-5 block">{{
				$t("Save")
			}}</vs-button>
		</vx-card>

		<vx-card :title="$t('Languages.Languages') + ' ' + $t('MapModule.Default')" class="mb-base" id="language">
			<label class="vs-input--label">{{ $t("Languages.Languages") }}</label>
			<vx-input-group class="mb-base">
				<template slot="prepend">
					<div class="prepend-text border-solid d-theme-border-grey-light">
						<span class="cursor-pointer flex items-center i18n-locale">
							<img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
						</span>
					</div>
				</template>

				<v-select
					v-model="language"
					:clearable="false"
					:options="languageOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
				</v-select>
			</vx-input-group>

			<vs-button type="filled" @click.prevent="updatePreferences('language')" class="mt-5 block">{{
				$t("Save")
			}}</vs-button>
		</vx-card>

		<vx-card :title="$t('Notification.AppNotifications')" class="mb-base" id="notifications">
			<div class="vx-row">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.NotificationNumberDays") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<v-select
						v-model="numDays"
						:clearable="false"
						:options="[1, 2, 3, 4, 5, 6, 7]"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
					</v-select>
				</div>
			</div>

			<div class="vx-row mt-4">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.NotificationNumber") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<v-select
						v-model="numNotification"
						:clearable="false"
						:options="[50, 100, 300, 500, 1000]"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
					>
					</v-select>
				</div>
			</div>

			<div class="vx-row mt-4">
				<div class="vx-col w-1/2 items-center sm:flex hidden">
					<p class="mb-4">{{ $t("Preferences.DeleteOldNotification") }}</p>
				</div>
				<div class="vx-col w-1/2">
					<vs-switch class="mt-2" color="success" v-model="removeOldNotification" />
				</div>
			</div>

			<vs-button type="filled" @click.prevent="updatePreferences('notifications')" class="mt-5">{{
				$t("Save")
			}}</vs-button>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			filterType: false,
			language: {value: "es", label: this.$t("Languages.Spanish")},
			numDays: 1,
			numNotification: 100,
			removeOldNotification: false,
		};
	},
	computed: {
		languageOptions() {
			return [
				{value: "es", label: this.$t("Languages.Spanish")},
				{value: "en", label: this.$t("Languages.English")},
				{value: "pt", label: this.$t("Languages.Portuguese")},
			];
		},
		i18n_locale_img() {
			const locale = this.language.value;
			if (locale === "en") return require("@/assets/images/flags/en.png");
			else if (locale === "pt") return require("@/assets/images/flags/br.svg");
			else if (locale === "fr") return require("@/assets/images/flags/fr.png");
			else if (locale === "de") return require("@/assets/images/flags/de.png");
			else if (locale === "es") return require("@/assets/images/flags/es.png");
			else return require("@/assets/images/flags/en.png");
		},
		getCurrentLocaleData() {
			const locale = this.$i18n.locale;
			if (locale === "en") return {flag: "us", lang: this.$t("Languages.English")};
			else if (locale === "pt") return {flag: "br", lang: this.$t("Languages.Portuguese")};
			else if (locale === "fr") return {flag: "fr", lang: this.$t("Languages.French")};
			else if (locale === "de") return {flag: "de", lang: this.$t("Languages.German")};
			else if (locale === "es") return {flag: "es", lang: this.$t("Languages.Spanish")};
		},
	},
	methods: {
		updateLocale(locale) {
			this.language = this.languageOptions.find((language) => language.value === locale);
		},
		async updatePreferences(preferenceName) {
			const payload = {};

			if (preferenceName === "filter_exact_values") {
				payload[preferenceName] = this.filterType;
			}

			if (preferenceName === "notifications") {
				payload["notifications_days"] = this.numDays;
				payload["notifications_number"] = this.numNotification;
				payload["remove_old_notifications"] = this.removeOldNotification;
			}

			if (preferenceName === "language") {
				payload[preferenceName] = this.language.value;
			}

			try {
				await this.$store.dispatch("modulePreferences/updatePreferences", payload);
				this.$vs.notify({
					color: "success",
					title: this.$t("Preferences.Preferences"),
					text: this.$t("Setting.Saved"),
				});

				if (preferenceName === "notifications") {
					this.$store.commit("setReloadNotificationTrigger");
				}

				if (preferenceName === "language") {
					this.$i18n.locale = this.language.value;
					this.$store.commit("UPDATE_LOCALE_APP", this.language.value);
				}
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		update(payload) {
			this.$store.dispatch("modulePreferences/updatePreferences", payload);
		},
		moveScroll(id) {
			const elem = document.getElementById(id);
			elem.scrollIntoView();
		},
	},
	created() {
		this.filterType = this.$store.state.modulePreferences.filter_exact_values;
		this.numDays = this.$store.state.modulePreferences.notifications_days;
		this.numNotification = this.$store.state.modulePreferences.notifications_number;
		this.removeOldNotification = this.$store.state.modulePreferences.remove_old_notifications;
		this.updateLocale(this.$store.state.modulePreferences.language);
	},
	mounted() {
		const preferenceId = this.$route.params.id;
		if (preferenceId) this.moveScroll(preferenceId);
	},
};
</script>
